import { render } from "./404.vue?vue&type=template&id=4373fb4f"
import script from "./404.vue?vue&type=script&lang=ts"
export * from "./404.vue?vue&type=script&lang=ts"

import "./404.vue?vue&type=style&index=0&id=4373fb4f&lang=scss"
script.render = render

export default script